import { FunctionComponent } from 'react';
import University from '../../../../networking/models/University';
import ColorLegend from './ColorLegend';

interface Props {
    colors: string[];
    universities: University[];
}

const CompareTitle: FunctionComponent<Props> = ({ colors, universities }) => {
    return (
        <div className={'compare-page__title'}>
            <h1 className={'compare-page__text--title'}>Compare</h1>

            <div className={'compare-page__section'}>
                { universities.map((university, index) => (
                    <ColorLegend color={colors[index]} key={university.id}>{ university.name }</ColorLegend>
                )) }
            </div>
        </div>
    );
};

export default CompareTitle;
